<template>
  <v-app>
    <v-app-bar app color="white">
      <v-img
        style="max-width: 70%"
        contain
        max-height="50%"
        src="@/assets/images/Simple-Software-logo.jpg"
      ></v-img>
      <div v-if="$vuetify.breakpoint.smAndUp" id="et-top-navigation">
        <nav id="top-menu-nav">
          <ul id="top-menu" class="nav">
            <li class="">
              <a v-on:click="$vuetify.goTo('#services', options)">Services</a>
            </li>
            <li class="">
              <a v-on:click="$vuetify.goTo('#testimonials', options)"
                >Testimonials</a
              >
            </li>
            <li>
              <a v-on:click="$vuetify.goTo('#contact', options)">Contact</a>
            </li>
          </ul>
        </nav>
      </div>
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            v-if="!$vuetify.breakpoint.smAndUp"
          >
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title v-on:click="$vuetify.goTo('#services', options)"
              >Services</v-list-item-title
            >
          </v-list-item>
          <v-list-item>
            <v-list-item-title
              v-on:click="$vuetify.goTo('#testimonials', options)"
              >Testimonials</v-list-item-title
            >
          </v-list-item>
          <v-list-item>
            <v-list-item-title v-on:click="$vuetify.goTo('#contact', options)"
              >Contact</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-content class="pa-0">
      <section id="hero">
        <v-row no-gutters>
          <v-img :height="'70vh'" src="">
            <video
              loop="loop"
              autoplay=""
              playsinline=""
              muted=""
              width="100vw"
              id="mejs_40906796360439235_html5_html5"
              preload="none"
              src="https://simple-software-tools.s3-ap-southeast-2.amazonaws.com/Simple-01d.mp4"
              :style="`margin: 0px; min-width: 100vw; min-height: 70vh; object-fit: fill;`"
            >
              <source
                type="video/mp4"
                src="https://simple-software-tools.s3-ap-southeast-2.amazonaws.com/Simple-01d.mp4"
              />
            </video>
            <v-theme-provider dark>
              <v-container
                fill-height
                style="
                  left: 50%;
                  top: 50%;
                  transform: translate(-50%, -50%);
                  width: 100vw;
                  position: absolute;
                "
              >
                <v-row
                  align="center"
                  class="white--text mx-auto"
                  justify="center"
                >
                  <v-col class="white--text text-center" cols="12" tag="h1">
                    <div
                      v-if="$vuetify.breakpoint.smAndUp"
                      style="
                        font-size: 50pt;
                        margin: auto;
                        color: white;
                        max-width: 900px;
                      "
                      ref="HeroText"
                      class="whiteVueTyper"
                    >
                      <vue-typer
                        v-if="startTypers"
                        :text="[
                          formatText(
                            '<Data capture, tracking and reporting/>',
                            'HeroText',
                            36.66
                          ),
                          formatText(
                            '<Business process automation/>',
                            'HeroText',
                            36.66
                          ),
                          formatText(
                            '<Run your business more effectively/>',
                            'HeroText',
                            36.66
                          ),
                        ]"
                        :repeat="Infinity"
                        :shuffle="false"
                        initial-action="typing"
                        :pre-type-delay="70"
                        :type-delay="70"
                        :pre-erase-delay="2000"
                        :erase-delay="50"
                        erase-style="backspace"
                        :erase-on-complete="false"
                        caret-animation="blink"
                      ></vue-typer>
                    </div>
                    <div
                      v-else
                      style="
                        font-size: 30pt;
                        margin: auto;
                        color: white;
                        max-width: 900px;
                      "
                      ref="HeroText"
                      class="whiteVueTyper"
                    >
                      <vue-typer
                        v-if="startTypers"
                        :text="[
                          formatText(
                            '<Data capture, tracking and reporting/>',
                            'HeroText'
                          ),
                          formatText(
                            '<Business process automation/>',
                            'HeroText'
                          ),
                          formatText(
                            '<Run your business more effectively/>',
                            'HeroText'
                          ),
                        ]"
                        :repeat="Infinity"
                        :shuffle="false"
                        initial-action="typing"
                        :pre-type-delay="70"
                        :type-delay="70"
                        :pre-erase-delay="2000"
                        :erase-delay="50"
                        erase-style="backspace"
                        :erase-on-complete="false"
                        caret-animation="blink"
                      ></vue-typer>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-theme-provider>
            <div
              style="
                height: 100px;
                width: 100vw;
                position: absolute;
                bottom: 0px;
              "
            >
              <v-img
                style="height: 100px; width: 100%"
                src="@/assets/images/angledEdge.svg"
              ></v-img>
            </div>
          </v-img>
        </v-row>
      </section>

      <section id="services" class="pa-4 px-md-10 mx-md-10">
        <v-row style="text-align: left" class="pa-4 ma-4">
          <v-col cols="12" md="6">
            <h1 style="font-size: 35pt; max-width: 400px; margin: auto">
              We solve your business challenges with custom software
            </h1>
          </v-col>
          <v-col cols="12" md="6">
            <v-row style="max-width: 600px">
              <v-col cols="12" md="8">
                <h2>Streamline a process, or your whole business...</h2>
              </v-col>
              <v-col cols="12">
                <p>
                  From CRM automation to Xero integration, consolidating and
                  integrating data or enhancing existing systems, we work with
                  you to understand your business challenges, and then design
                  and build custom software that automates and refines business
                  processes so you have more time to grow.
                </p>
              </v-col>
              <v-col cols="12">
                <p>
                  Simple Software began after Deane and Abbie moved back to New
                  Zealand from the States to raise their girls. Deane has worked
                  in the IT industry for more than 20 years, he and his team
                  specialise in solving business problems with custom software.
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </section>

      <section
        id="features"
        style="background: #ef592a; height: 300px; position: relative"
      >
        <div
          style="
            height: 50px;
            width: 100vw;
            position: absolute;
            top: 0px;
            left: 0px
            -webkit-transform: scaleY(-1);
            transform: scaleY(-1);
          "
        >
          <v-img
            style="height: 100%; width: 100%"
            src="@/assets/images/angledEdge.svg"
          ></v-img>
        </div>
        <v-container
          class="text-center"
          style="
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            position: relative;
          "
        >
          <div
            style="
              font-size: 30pt;
              margin: auto;
              color: white;
              max-width: 900px;
            "
            ref="phrasesText"
            class="whiteVueTyper"
          >
            <vue-typer
              v-if="startTypers"
              :text="[
                formatText('Business efficiency consulting', 'phrasesText'),
                formatText('Systems design & architecture', 'phrasesText'),
                formatText('Xero Intergration', 'phrasesText'),
                formatText(
                  'Business & sales processes automation',
                  'phrasesText'
                ),
                formatText('Enhancing existing systems', 'phrasesText'),
                formatText('Data capture, tracking & reporting', 'phrasesText'),
                formatText('Design and build custom databaess', 'phrasesText'),
              ]"
              :repeat="Infinity"
              :shuffle="false"
              initial-action="typing"
              :pre-type-delay="70"
              :type-delay="70"
              :pre-erase-delay="2000"
              :erase-delay="50"
              erase-style="backspace"
              :erase-on-complete="false"
              caret-animation="blink"
            ></vue-typer>
          </div>
        </v-container>
        <div
          style="
            height: 50px;
            width: 100vw;
            position: absolute;
            bottom: 0px;
            left: 0px;
          "
        >
          <v-img
            style="height: 100%; width: 100%"
            src="@/assets/images/angledEdge.svg"
          ></v-img>
        </div>
      </section>

      <section class="py-10 my-md-10">
        <v-row style="text-align: left; width: 100vw">
          <v-col cols="12" sm="6" md="4" style="text-align: center">
            <v-img
              style="max-width: 180px; position: relative; margin: auto"
              src="@/assets/images/Icon-Light.jpg"
            ></v-img>
            <h2 class="mt-4">Consulting</h2>
          </v-col>
          <v-col cols="12" sm="6" md="4" style="text-align: center">
            <v-img
              style="max-width: 180px; position: relative; margin: auto"
              src="@/assets/images/Icon-Design.jpg"
            ></v-img>
            <h2 class="mt-4">Design</h2>
          </v-col>
          <v-col cols="12" sm="6" md="4" style="text-align: center">
            <v-img
              style="max-width: 180px; position: relative; margin: auto"
              src="@/assets/images/Icon-Development.jpg"
            ></v-img>
            <h2 class="mt-4">Development</h2>
          </v-col>
        </v-row>
      </section>

      <section
        id="testimonials"
        style="background: #2ab572 !important; width: 100vw; position: relative"
        class="pa-4 px-md-10"
      >
        <div
          style="
            height: 50px;
            width: 100vw;
            position: absolute;
            top: 0px;
            left: 0px;
            -webkit-transform: scaleY(-1) scaleX(-1);
            transform: scaleY(-1) scaleX(-1);
          "
        >
          <v-img
            style="height: 100%; width: 100%"
            src="@/assets/images/angledEdge.svg"
          ></v-img>
        </div>
        <v-row style="text-align: left" class="pa-4 py-10 ma-4 mx-md-10">
          <v-col cols="12" style="color: white">
            <div
              style="
                font-size: 30pt;
                margin: auto;
                color: white;
                max-width: 900px;
              "
              ref="testimonialText"
              class="whiteVueTyper"
            >
              <vue-typer
                v-if="startTypers"
                :text="[
                  formatText(
                    'Here\'s what our clients have to say...',
                    'testimonialText'
                  ),
                ]"
                :repeat="0"
                :shuffle="false"
                initial-action="typing"
                :pre-type-delay="70"
                :type-delay="70"
                :pre-erase-delay="2000"
                :erase-delay="100"
                erase-style="backspace"
                :erase-on-complete="false"
                caret-animation="blink"
              ></vue-typer>
            </div>
          </v-col>
          <v-col cols="12" style="color: white">
            <p style="margin: auto; color: white; max-width: 900px">
              “Simple Software has been instrumental in the development of
              UpstreamNZ. Our social enterprise involves lots of suppliers and
              transactions that a basic website was never going to be sufficient
              enough for. Simple Software listened to our needs, suggested
              multiple options that suited our timeline and budgets. Having a
              software developer you can trust is a critical component of any
              business. Simple Software’s experience, execution and friendliness
              made it easy for us to entrust our social enterprise to them. With
              already exceptional results, we get to rejoice together in the
              impact we’ve been able to achieve for our communities
              collaboratively. Would highly recommend their skill set to
              anyone!”
            </p>
            <br />
            <p
              style="
                margin: auto;
                color: white;
                max-width: 900px;
                font-weight: bold;
              "
            >
              Mitch Shaw
            </p>
            <p style="margin: auto; color: white; max-width: 900px">
              Co-Founder of social enterprise
              <span style="font-weight: bold">UpstreamNZ</span>
            </p>
          </v-col>
        </v-row>
        <div
          style="
            height: 50px;
            width: 100vw;
            position: absolute;
            bottom: 0px;
            left: 0px;
            -webkit-transform: scaleX(-1);
            transform: scaleX(-1);
          "
        >
          <v-img
            style="height: 100%; width: 100%"
            src="@/assets/images/angledEdge.svg"
          ></v-img>
        </div>
      </section>

      <!-- <section id="stats">
        <v-parallax
          :height="$vuetify.breakpoint.smAndDown ? 700 : 500"
          src="https://images.unsplash.com/photo-1510915228340-29c85a43dcfe?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80"
        >
          <v-container fill-height>
            <v-row class="mx-auto">
              <v-col
                v-for="[value, title] of stats"
                :key="title"
                cols="12"
                md="3"
              >
                <div class="text-center">
                  <div
                    class="display-3 font-weight-black mb-4"
                    v-text="value"
                  ></div>

                  <div
                    class="title font-weight-regular text-uppercase"
                    v-text="title"
                  ></div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-parallax>
      </section> -->

      <!-- <section id="blog">
        <div class="py-12"></div>

        <v-container>
          <h2
            class="display-2 font-weight-bold mb-3 text-uppercase text-center"
          >
            Blog
          </h2>

          <v-responsive class="mx-auto mb-12" width="56">
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <v-col
              v-for="({ src, text, title }, i) in articles"
              :key="i"
              cols="12"
              md="4"
            >
              <v-img
                :src="src"
                class="mb-4"
                height="275"
                max-width="100%"
              ></v-img>

              <h3
                class="font-weight-black mb-4 text-uppercase"
                v-text="title"
              ></h3>

              <div class="title font-weight-light mb-5" v-text="text"></div>

              <v-btn class="ml-n4 font-weight-black" text>
                Continue Reading
              </v-btn>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section> -->

      <section id="contact" class="pa-4 px-md-10 mx-md-10">
        <v-row style="text-align: left" class="pa-4 ma-4">
          <v-col cols="12" md="6">
            <div
              style="
                font-size: 30pt;
                margin: auto;
                color: white;
                max-width: 600px;
              "
              ref="getInTouchText"
            >
              <vue-typer
                v-if="startTypers"
                :text="[
                  formatText(
                    'Get in touch by filling out the form or calling this number...',
                    'getInTouchText'
                  ),
                ]"
                :repeat="0"
                :shuffle="false"
                initial-action="typing"
                :pre-type-delay="70"
                :type-delay="70"
                :pre-erase-delay="2000"
                :erase-delay="100"
                erase-style="backspace"
                :erase-on-complete="false"
                caret-animation="blink"
              ></vue-typer>
              <v-btn
                dark
                color="#ef592a"
                block
                style="height: 40pt"
                class="mt-4"
                @click="callSimpleSoftware()"
              >
                <span style="font-size: 20pt; font-weight: bold"
                  >022 197 5372</span
                >
              </v-btn>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <v-form ref="contactForm">
              <v-row style="max-width: 600px">
                <v-col cols="12" md="6">
                  <v-text-field
                    color="green"
                    filled
                    label="Name"
                    v-model="contactForm.name"
                    hide-details
                    :rules="[(v) => !!v || 'Name is required']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    color="green"
                    filled
                    label="Email Address"
                    :rules="[
                      (v) => !!v || 'E-mail is required',
                      (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                    ]"
                    v-model="contactForm.email"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    color="green"
                    filled
                    label="Message"
                    v-model="contactForm.message"
                    hide-details
                    :rules="[(v) => !!v || 'Message is required']"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    color="primary"
                    block
                    :loading="emailSending"
                    @click="submitContactForm"
                    >Send</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
      </section>
    </v-content>

    <section
      id="features"
      style="background: #a92378; height: 100px; position: relative"
    >
      <div
        style="
          height: 100px;
          width: 100vw;
          position: absolute;
          top: 0px;
          -webkit-transform: scaleY(-1) scaleX(-1);
          transform: scaleY(-1) scaleX(-1);
        "
      >
        <v-img
          style="height: 100%; width: 100%"
          src="@/assets/images/angledEdge.svg"
        ></v-img>
      </div>
    </section>
  </v-app>
</template>

<script>
  import { auth } from "@/firebase.js";
  import { mapGetters } from "vuex";
  import { VueTyper } from "vue-typer";

  export default {
    components: {
      VueTyper,
    },
    computed: {},
    data: () => ({
      articles: [
        {
          src:
            "https://images.unsplash.com/photo-1423784346385-c1d4dac9893a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80",
          title: "Mobile first & Responsive",
          text:
            "Phasellus lorem enim, luctus ut velit eget, convallis egestas eros. Sed ornare ligula eget tortor tempor, quis porta tellus dictum.",
        },
        {
          src:
            "https://images.unsplash.com/photo-1475938476802-32a7e851dad1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80",
          title: "Think outside the box",
          text:
            "Nam ut leo ipsum. Maecenas pretium aliquam feugiat. Aenean vel tempor est, vitae tincidunt risus. Sed sodales vestibulum nibh.",
        },
        {
          src:
            "https://images.unsplash.com/photo-1416339442236-8ceb164046f8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1892&q=80",
          title: "Small changes, big difference",
          text:
            "Vestibulum in dictum velit, in rhoncus nibh. Maecenas neque libero, interdum a dignissim in, aliquet vitae lectus. Phasellus lorem enim, luctus ut velit eget.",
        },
      ],
      features: [
        {
          icon: "mdi-account-group-outline",
          title: "Vibrant Community",
          text:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto cupiditate sint possimus quidem atque harum excepturi nemo velit tempora! Enim inventore fuga, qui ipsum eveniet facilis obcaecati corrupti asperiores nam",
        },
        {
          icon: "mdi-update",
          title: "Frequent Updates",
          text:
            "Sed ut elementum justo. Suspendisse non justo enim. Vestibulum cursus mauris dui, a luctus ex blandit. Lorem ipsum dolor sit amet consectetur adipisicing elit. qui ipsum eveniet facilis obcaecati corrupti consectetur adipisicing elit.",
        },
        {
          icon: "mdi-shield-outline",
          title: "Long-term Support",
          text:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto cupiditate sint possimus quidem atque harum excepturi nemo velit tempora! Enim inventore fuga, qui ipsum eveniet facilis obcaecati corrupti asperiores nam",
        },
      ],
      stats: [
        ["24k", "Github Stars"],
        ["330+", "Releases"],
        ["1m", "Downloads/mo"],
        ["5m", "Total Downloads"],
      ],
      contactForm: {},
      startTypers: false,
      options: {
        duration: 1000,
        offset: 0,
        easing: "easeInOutCubic",
      },
      emailSending: false,
    }),
    watch: {},
    mounted() {
      setTimeout(() => {
        this.startTypers = true;
      }, 150);
    },
    methods: {
      callSimpleSoftware() {
        window.open("tel:0221975372");
      },
      formatText(text, ref, textSize = 22) {
        let maxChars = Math.floor(this.$refs[ref].clientWidth / textSize);
        let words = text.split(" ");
        let breaked = "";
        let currentCount = 0;
        words.forEach((word) => {
          currentCount += word.length;
          currentCount += 1;
          if (currentCount >= maxChars) {
            currentCount = word.length;
            breaked = `${breaked}\n${word} `;
          } else {
            breaked = `${breaked}${word} `;
          }
        });
        return breaked;
      },
      submitContactForm() {
        this.emailSending = true;
        this.$store.dispatch("sendContactForm", this.contactForm).then(() => {
          this.emailSending = false;
          this.$swal({
            title: "Email Sent",
            text:
              "Thank you for your email. We aim to respond to all emails ASAP",
            type: "success",
            cancelButtonText: "Close",
          });
        });
      },
    },
  };
</script>

<style>
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: "Roboto Mono", monospace;
    color: black;
    line-height: 1.2;
  }
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
  #et-top-navigation {
    --wp-admin-theme-color: #007cba;
    --wp-admin-theme-color-darker-10: #006ba1;
    --wp-admin-theme-color-darker-20: #005a87;
    -webkit-font-smoothing: antialiased;
    color: #222222;
    line-height: 23px;
    text-align: left;
    box-sizing: border-box;
    margin: 0;
    border: 0;
    outline: 0;
    font-size: 100%;
    vertical-align: baseline;
    background: transparent;
    font-weight: 600;
    float: right;
    font-family: "Roboto Mono", monospace;
    transition: all 0.4s ease-in-out;
    padding: 23px 0 0 0;
  }
  #top-menu-nav {
    --wp-admin-theme-color: #007cba;
    --wp-admin-theme-color-darker-10: #006ba1;
    --wp-admin-theme-color-darker-20: #005a87;
    -webkit-font-smoothing: antialiased;
    color: #222222;
    text-align: left;
    font-size: 100%;
    font-weight: 600;
    font-family: "Roboto Mono", monospace;
    box-sizing: border-box;
    display: block;
    line-height: 0;
    float: left;
  }
  #top-menu {
    --wp-admin-theme-color: #007cba;
    --wp-admin-theme-color-darker-10: #006ba1;
    --wp-admin-theme-color-darker-20: #005a87;
    -webkit-font-smoothing: antialiased;
    color: #222222;
    text-align: left;
    font-weight: 600;
    font-family: "Roboto Mono", monospace;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    font-size: 100%;
    vertical-align: baseline;
    background: transparent;
    list-style: none;
    list-style-type: none;
    line-height: 0;
    float: left;
  }
  #top-menu li {
    display: inline;
    --wp-admin-theme-color: #007cba;
    --wp-admin-theme-color-darker-10: #006ba1;
    --wp-admin-theme-color-darker-20: #005a87;
    -webkit-font-smoothing: antialiased;
    color: #222222;
    font-weight: 600;
    font-family: "Roboto Mono", monospace;
    list-style: none;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    vertical-align: baseline;
    background: transparent;
    position: relative;
    line-height: 1em;
    display: inline-block;
    font-size: 14px;
    padding-right: 22px;
  }
  #top-menu li a {
    --wp-admin-theme-color: #007cba;
    --wp-admin-theme-color-darker-10: #006ba1;
    --wp-admin-theme-color-darker-20: #005a87;
    -webkit-font-smoothing: antialiased;
    font-weight: 600;
    font-family: "Roboto Mono", monospace;
    list-style: none;
    line-height: 1em;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    vertical-align: baseline;
    background: transparent;
    text-decoration: none;
    display: block;
    position: relative;
    transition: all 0.4s ease-in-out;
    color: #000000;
    font-size: 18px;
    padding-bottom: 23px;
  }
  .vue-typer {
    font-family: "Roboto Mono", monospace;
    color: white;
    line-height: 1.2;
    font-weight: bold;
  }

  .whiteVueTyper span.char.custom.typed {
    color: white !important;
  }

  .vue-typer .custom.caret {
    width: 4px;
  }

  .whiteVueTyper .vue-typer .custom.caret {
    background-color: white;
  }
</style>

<style lang="scss">
  .custom.caret {
    &.complete {
      /* Styles for the idle caret when VueTyper has finished all typing/erasing */
      display: inline-block;
    }
  }
</style>
